// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CorrectionRequests_wrapper__3YG3P","loading":"CorrectionRequests_loading__4bPNW"};